import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { cartLineCardCondensedStyles } from "@insite/content-library/Components/CartLineCardCondensed";

cartLineCardCondensedStyles.extendedUnitNetPrice = mergeToNew(cartLineCardCondensedStyles.extendedUnitNetPrice, {
    text: {
        weight: 700,
        color: "text.accent",
    },
});
